// extracted by mini-css-extract-plugin
export default {"container":"RdfpKa","report":"fCI6EC mz-link","cloud":"bgOGMx mz-primary-icon","tabsContent":"CwLG6E"};